import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Form, Formik, FormikHelpers, useFormikContext } from 'formik';
import { object } from 'yup';

import { UserAvatar } from '@components/Feature/User/user-avatar';
import { UserOtpCodeFormGroup } from '@components/Feature/User';
import { useDispatch, useSelector } from 'react-redux';
import { ServerError } from '@components/Helper';
import { useRouteParam } from '@hooks/params';
import { yupOtpCode } from '@utils/yup';

import {
  otpCodeVerify,
  OtpCodeVerifyPayload,
  otpCodeCheck,
  OtpCodeCheckPayload,
} from '../action';
import { selectAuthRouteReducer } from '../selector';

type FormValues = OtpCodeVerifyPayload;

const FormForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { serverErrors } = useSelector(selectAuthRouteReducer);
  const { values, isSubmitting } = useFormikContext<FormValues>();
  const { mobileNumber } = values;

  return (
    <Form>
      <UserOtpCodeFormGroup
        onRequest={() => {
          const payload: OtpCodeCheckPayload = { mobileNumber };
          dispatch(otpCodeCheck(payload));
        }}
      />

      <div className="d-grid gap-2">
        <Button type="submit" disabled={isSubmitting} variant="primary">
          {t('common:signIn')}
        </Button>
        <Button variant="outline-secondary" onClick={() => navigate('-1')}>
          {t('common:enterWrongNumber')}
        </Button>
      </div>
      <ServerError errors={serverErrors} />
    </Form>
  );
}

const AuthOtpCodePage = () => {
  const { t } = useTranslation();
  const mobileNumber = useRouteParam('mobileNumber')!;
  const dispatch = useDispatch();

  const initialValues: FormValues = {
    mobileNumber,
    otpCode: '',
  };

  const validationSchema = object({
    otpCode: yupOtpCode(),
  });

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    const payload: OtpCodeVerifyPayload = values;
    dispatch(otpCodeVerify(payload));
    setSubmitting(false);
  };

  return (
    <Card>
      <Card.Header className="text-center">
        <UserAvatar />
      </Card.Header>
      <Card.Body>
        <Card.Title>{t('registration.otpCode.title')}</Card.Title>
        <Card.Text>
          {t('registration.otpCode.desc')}
          &nbsp;
          <strong>{mobileNumber}</strong>
        </Card.Text>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          <FormForm />
        </Formik>
      </Card.Body>
    </Card>
  );
};

export { AuthOtpCodePage };
